export { ResidentialIcon } from './ResidentialIcon'
